import React, { useState } from "react";
import { Col } from "styled-bootstrap-grid";
import DropDown from "../DropDown";
import { Flexed, Spacer, Text } from "../../styled/shared";
import styled from "styled-components";
import { palette } from "../../styled/colors";
import DateTimePicker from "react-datetime-picker";
import Checkbox from "../common/CheckBox";
import CustomInputField from "../common/CustomInputField";
import Toggle from "../common/Toggle";
import ChemicalsErrorModal from "../modals/ChemicalsErrorModal";
import AllowToOrderModal from "../modals/AllowToOrderModal";
import { BiCalendarAlt } from "react-icons/bi";
import { media } from "styled-bootstrap-grid";
import { CustomDivTitle } from "../productStepper/ProductStepperTwo";
import { toastSuccess } from "../../styled/toastStyle";
import { toast } from "react-toastify";
import AutoComplete from "../common/AutoComplete";
import { PickupTimeTable } from "../CreateProducts";
import GooglePlacesInput from "../GooglePlacesInput";

const EditProductStepperTwo = ({
  isFarmerMarket,
  setIsFarmerMarket,
  isOrganicError,
  setIsOrganicError,
  chemicalCheckBoxNone,
  setChemicalCheckBoxNone,
  isDelivery,
  isPickUp,
  setIsDelivery,
  setIsPickUp,
  distanceError,
  setDistanceError,
  setDistance,
  isTrade,
  distance,
  setAllowToOrder,
  allowToOrder,
  hoursOptions,
  setHoursOptions,
  setInventoryPriceError,
  inventoryPrice,
  inventoryPriceError,
  setInventoryPrice,
  startDateError,
  setDays,
  daysError,
  handleStartDateChange,
  startDate,
  setDaysOption,
  daysOption,
  days,
  setDaysError,
  setHoursError,
  hoursError,
  setHours,
  hours,
  endDateError,
  handleEndDateChange,
  endDate,
  setCaptionError,
  setCaption,
  captionError,
  caption,
  setQuantityError,
  quantityError,
  quantity,
  allowToOrderError,
  setAllowToOrderError,
  chemicalsError,
  setChemicalsError,
  setQuantity,
  allowToOrderOptions,
  setToggle,
  setIsAddChemicalsModalOpen,
  toggle,
  chemicals,
  chemicalsUsed,
  setChemicalsUsed,
  setUnlimited,
  unLimitted,
  privateLocation,
  setprivateLocation,
  pickupTimetable,
  setPickupTimetable,
  setPickupLocation,
  serviceFee,
  setServiceFee,
  deliveryFee,
  setDeliveryFee,
  specialInstructions,
  setSpecialInstructions
}) => {
  const [isAllowToOrderModalOpen, setIsAllowToOrderModalOpen] = useState(false);
  const [isChemicalsErrorModalOpen, setIsChemicalsErrorModalOpen] =
    useState(false);

  const options = [
    { id: 1, label: "10:00 AM", value: "10:00 AM" },
    { id: 2, label: "11:00 AM", value: "11:00 AM" },
    { id: 3, label: "12:00 PM", value: "12:00 PM" },
    { id: 4, label: "01:00 PM", value: "01:00 PM" },
    { id: 5, label: "02:00 PM", value: "02:00 PM" },
    { id: 6, label: "03:00 PM", value: "03:00 PM" },
    { id: 7, label: "04:00 PM", value: "04:00 PM" },
    { id: 8, label: "05:00 PM", value: "05:00 PM" },
    { id: 9, label: "06:00 PM", value: "06:00 PM" },
    { id: 10, label: "07:00 PM", value: "07:00 PM" },
    { id: 11, label: "08:00 PM", value: "08:00 PM" },
    { id: 12, label: "09:00 PM", value: "09:00 PM" },
    { id: 13, label: "10:00 PM", value: "10:00 PM" }
  ];

  const [selectedDays, setSelectedDays] = useState<string[]>([]);

  const handleCheck = (day: string) => {
    let updated: string[] = [];
    if (selectedDays.includes(day)) {
      updated = selectedDays.filter((d) => d !== day);
    } else {
      updated = [...selectedDays, day];
    }

    setSelectedDays(updated);
    setPickupTimetable((prev: PickupTimeTable) => ({ ...prev, days: updated }));
    // getPickupTimetable({ isPickup });
  };

  return (
    <>
      {isTrade === "Sell" && (
        <>
          <Col lg={6}>
            <CustomInputField
              modal={true}
              bgTransparent
              setIsAllowToOrderModalOpen={setIsAllowToOrderModalOpen}
              label="Allow to order in advance "
              placeholder="Enter"
              handleChange={(value: any) => {
                let reg: any = "";
                if (value === "") {
                  setDaysError("Days is required");
                }
                setDaysError("");
                if (allowToOrder === "Hour(s)") {
                  reg = /^(?:[0-9]|1[0-9]|2[0-3])?$/;

                  if (reg.test(value.toString())) {
                    setDays(value.toString());
                  }
                } else if (allowToOrder === "Day(s)") {
                  reg = /^(?:[1-9]|10)?$/;
                  if (reg.test(value.toString())) {
                    setDays(value.toString());
                  }
                }
              }}
              required
              error={daysError}
              errorMsg={daysError}
              allowOnlyNumbers={true}
              value={days}
            />
            <Spacer height={1.5} />
          </Col>

          <Col lg={6}>
            <CustomSpacer />
            <DropDown
              // disabled={!allowToOrder}
              firstSelected={allowToOrder}
              required
              // name="unit"
              hasChanged={(value: any) => {
                setAllowToOrderError("");
                if (value === "") {
                  setAllowToOrderError("Allow To Order is required");
                }
                setAllowToOrder(value);
                if (value === "Day(s)") {
                  setDays(1);
                } else if (value === "Hour(s)") {
                  setDays(0);
                }
              }}
              error={allowToOrderError}
              errorMsg={allowToOrderError}
              options={allowToOrderOptions}
            />
            <Spacer height={1.5} />
          </Col>
        </>
      )}

      <Col lg={6}>
        <InputWrapper>
          <Text
            type="normal"
            margin="0rem 0rem 0.25rem 0rem"
            color="black"
            fontWeight={700}
          >
            Product available from
          </Text>
          <CalenderDiv
            calendarIcon={<CalendarIconCustom />}
            clearIcon={null}
            minDate={new Date()}
            disableClock={true}
            format="MM-d-y"
            onChange={handleStartDateChange}
            value={startDate}
          />
          <Text
            fontSize={0.625}
            type="small"
            color="danger"
            textTransform="lowercase"
          >
            {startDateError}
          </Text>
        </InputWrapper>
        <Spacer height={1.5} />
      </Col>

      <Col lg={6}>
        <InputWrapper>
          {/* <Text type="normal"  margin="0rem 0rem 0.25rem 0rem" color='black' fontWeight={700}>Ends on</Text> */}
          <CustomDivTitle>
            <Text
              type="normal"
              margin="0rem 0rem 0.25rem 0rem"
              color="black"
              fontWeight={700}
            >
              Ends on
            </Text>
            <Checkbox
              fontSize="1rem"
              type="normal"
              margin="0rem 0rem 0.25rem 0rem"
              color="black"
              fontWeight={700}
              label="Unlimitted"
              isChecked={unLimitted}
              setIsChecked={setUnlimited}
            />
          </CustomDivTitle>
          <CalenderDiv
            disabled={unLimitted}
            calendarIcon={<CalendarIconCustom />}
            clearIcon={null}
            minDate={startDate}
            disableClock={true}
            format="MM-d-y"
            onChange={handleEndDateChange}
            value={endDate}
          />
          <Text
            fontSize={0.625}
            type="small"
            color="danger"
            textTransform="lowercase"
          >
            {endDateError}
          </Text>
        </InputWrapper>
        <Spacer height={1.5} />
      </Col>

      {/* <Col lg={6}>
				<StyledFlex>
					<Flexed direction="row" align="center" justify="space-between">
						<Checkbox fontSize="1rem" label="Allow To Order" isChecked={allowToOrder} setIsChecked={setAllowToOrder} />
					</Flexed>
				</StyledFlex>
				<Spacer height={2} />
			</Col> */}

      <Col lg={12} sm={8}>
        <StyledFlex>
          <ResponsiveCheckboxContainer>
            <CheckboxItem>
              <Checkbox
                fontSize="1rem"
                type="normal"
                margin="0rem 0rem 0.25rem 0rem"
                color="black"
                fontWeight={700}
                label="Pick-Up"
                isChecked={pickupTimetable.isPickup}
                setIsChecked={() =>
                  setPickupTimetable((prev: PickupTimeTable) => ({
                    ...prev,
                    isPickup: !prev.isPickup
                  }))
                }
              />
            </CheckboxItem>
            <CheckboxItem>
              <Checkbox
                fontSize="1rem"
                type="normal"
                margin="0rem 0rem 0.25rem 0rem"
                color="black"
                fontWeight={700}
                label="Delivery"
                isChecked={isDelivery}
                setIsChecked={setIsDelivery}
              />
            </CheckboxItem>
            <CheckboxItem>
              <div
                style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}
              >
                <Checkbox
                  fontSize="1rem"
                  type="normal"
                  margin="0rem 0rem 0.25rem 0rem"
                  color="black"
                  fontWeight={700}
                  label="Farmer Market"
                  isChecked={isFarmerMarket}
                  setIsChecked={(val) => {
                    setIsFarmerMarket(val);
                    setPickupTimetable((prev: PickupTimeTable) => ({
                      ...prev,
                      isPickup: true
                    }));
                    if (val) {
                      setprivateLocation(false);
                    }
                  }}
                />
                <div
                  style={{ cursor: "pointer", fontWeight: "bold" }}
                  onClick={() => {
                    if (!isFarmerMarket) {
                    toast.success(
                      "If you attend different markets on different days, go to your account > Posts > Copy Post, and update the location and days as needed. Once you receive an order, prepare it for buyers to pick up. Your location will be fully disclosed on our platform",
                      {
                        autoClose: 10000,
                        toastId: "farmerMarketInfo" // Add unique ID to prevent duplicate toasts
                      }
                    );
                    }
                  }}
                >
                  [ ! ]
                </div>
              </div>
            </CheckboxItem>
            <CheckboxItem>
              <div
                style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}
              >
                <Checkbox
                  fontSize="1rem"
                  type="normal"
                  margin="0rem 0rem 0.25rem 0rem"
                  color="black"
                  fontWeight={700}
                  label="Private Location"
                  isChecked={privateLocation}
                  setIsChecked={(val) => {
                    setprivateLocation(val);
                    if (val) {
                      setIsFarmerMarket(false);
                    }
                  }}
                />
                <div
                  style={{ cursor: "pointer", fontWeight: "bold" }}
                  onClick={() => {
                    if (!privateLocation) {
                      toast.success(
                        "Your private location will only display the city, state, and zip code to the public. Your complete address will be included in the order confirmation sent to the buyer's email. You can connect on Gamba for further communication.",
                        {
                          autoClose: 10000,
                          toastId: "privateLocationInfo" // Add unique ID to prevent duplicate toasts
                        }
                      );
                    }
                  }}
                >
                  [ ! ]
                </div>
              </div>
            </CheckboxItem>
          </ResponsiveCheckboxContainer>
        </StyledFlex>
        <Spacer height={2} />
      </Col>

      {isFarmerMarket && !pickupTimetable.isPickup && (
        <div style={{ width: "100%" }}>
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            <Col lg={6} md={6} sm={12} xs={12}>
              <div
                style={{
                  fontSize: "1rem",
                  fontWeight: "700",
                  color: "#3F3F41"
                }}
              >
                Pickup Location
              </div>
              <GooglePlacesInput
                onSelect={(addr) => setPickupLocation(addr)}
                inputStyle={{
                  fontStyle: "normal",
                  backgroundColor: "white",
                  height: "42px",
                  width: "100%"
                }}
                placeholder="Enter your complete pickup location"
                saveLatLng={(res: { lat: number; lng: number }) => {
                  const { lat, lng } = res;

                  setPickupTimetable((prev: PickupTimeTable) => ({
                    ...prev,
                    pickup_lat: lat,
                    pickup_lng: lng,
                    pickup_location_err: ""
                  }));
                }}
              />
              <Spacer height={1.5} />
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <CustomInputField
                // maxLength={500}
                type="textarea"
                bgTransparent
                label="Special instructions"
                placeholder=""
                handleChange={(e: any) => {
                  const words = e.split(" ");
                  if (words.length > 149) {
                    const truncatedValue = words.slice(0, 149).join(" ");
                    setSpecialInstructions(truncatedValue);
                  } else {
                    setSpecialInstructions(e);
                  }
                }}
                value={specialInstructions}
                required
                textAreaRows={2}
              />
              <Spacer height={1.5} />
            </Col>
          </div>
        </div>
      )}

      {pickupTimetable.isPickup && (
        <div style={{ width: "100%" }}>
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            <Col lg={6} md={6} sm={12} xs={12}>
              <div
                style={{
                  fontSize: "1rem",
                  fontWeight: "700",
                  color: "#3F3F41"
                }}
              >
                Pickup Location
              </div>
              <GooglePlacesInput
                onSelect={(addr) => setPickupLocation(addr)}
                inputStyle={{
                  fontStyle: "normal",
                  backgroundColor: "white",
                  height: "42px",
                  width: "100%"
                }}
                placeholder="Enter your complete pickup location"
                saveLatLng={(res: { lat: number; lng: number }) => {
                  const { lat, lng } = res;

                  setPickupTimetable((prev: PickupTimeTable) => ({
                    ...prev,
                    pickup_lat: lat,
                    pickup_lng: lng,
                    pickup_location_err: ""
                  }));
                }}
              />

              {pickupTimetable.isPickup &&
                pickupTimetable.pickup_location_err && (
                  <Text
                    fontSize={0.625}
                    type="small"
                    color="danger"
                    textTransform="lowercase"
                    style={{ position: "relative" }}
                  >
                    {pickupTimetable.pickup_location_err}
                  </Text>
                )}

              <Spacer height={1.5} />
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <CustomInputField
                // maxLength={500}
                type="textarea"
                bgTransparent
                label="Special instructions"
                placeholder=""
                handleChange={(e: any) => {
                  const words = e.split(" ");
                  if (words.length > 149) {
                    const truncatedValue = words.slice(0, 149).join(" ");
                    setSpecialInstructions(truncatedValue);
                  } else {
                    setSpecialInstructions(e);
                  }
                }}
                value={specialInstructions}
                required
                textAreaRows={2}
              />
              <Spacer height={1.5} />
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <>
                <Flexed direction="row" gap="1" style={{ flexWrap: "wrap" }}>
                  <div style={{ flex: "1 1 40%", minWidth: "140px" }}>
                    <div
                      style={{
                        fontSize: "1rem",
                        fontWeight: "700",
                        color: "#3F3F41"
                      }}
                    >
                      Pickup Time
                    </div>
                    <div>
                      <DropDown
                        required
                        hasChanged={(value: any) => {
                          setPickupTimetable((prev: PickupTimeTable) => ({
                            ...prev,
                            pickup_start_time: value,
                            pick_start_time_err: ""
                          }));
                        }}
                        options={options}
                      />
                    </div>
                  </div>
                  <div style={{ flex: "1 1 40%", minWidth: "140px" }}>
                    <div
                      style={{
                        fontSize: "1rem",
                        fontWeight: "700",
                        color: "#3F3F41"
                      }}
                    >
                      Closing Time
                    </div>

                    <DropDown
                      required
                      hasChanged={(value: any) => {
                        setPickupTimetable((prev: PickupTimeTable) => ({
                          ...prev,
                          pickup_end_time: value,
                          pick_end_time_err: ""
                        }));
                      }}
                      options={options}
                    />
                  </div>
                </Flexed>
                {pickupTimetable.pick_start_time_err && (
                  <Text
                    fontSize={0.625}
                    type="small"
                    color="danger"
                    textTransform="lowercase"
                    style={{ position: "relative" }}
                  >
                    {pickupTimetable.pick_start_time_err}
                  </Text>
                )}
                {pickupTimetable.pick_end_time_err && (
                  <Text
                    fontSize={0.625}
                    type="small"
                    color="danger"
                    textTransform="lowercase"
                    style={{ position: "relative", marginTop: "5px" }}
                  >
                    {pickupTimetable.pick_end_time_err}
                  </Text>
                )}

                <Spacer height={1.5} />
              </>
            </Col>
          </div>
          <Col lg={12} md={12} sm={12} xs={12}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px"
              }}
            >
              <p
                style={{
                  fontSize: "1rem",
                  fontWeight: "700",
                  color: "#3F3F41",
                  marginBottom: "5px"
                }}
              >
                Pickup Days{" "}
              </p>
              <WeekDays className="weekdays">
                {[
                  { day: "MONDAY", label: "Mon." },
                  { day: "TUESDAY", label: "Tue." },
                  { day: "WEDNESDAY", label: "Wed." },
                  { day: "THURSDAY", label: "Thurs." },
                  { day: "FRIDAY", label: "Fri." },
                  { day: "SATURDAY", label: "Sat." },
                  { day: "SUNDAY", label: "Sun." }
                ].map(({ day, label }) => (
                  <Checkbox
                    key={day}
                    setIsChecked={() => handleCheck(day)}
                    isChecked={selectedDays.includes(day)}
                    label={label}
                  />
                ))}
              </WeekDays>
            </div>
            {pickupTimetable.isPickup && pickupTimetable.days.length === 0 && (
              <Text
                fontSize={0.625}
                type="small"
                color="danger"
                textTransform="lowercase"
                style={{ position: "relative" }}
              >
                {pickupTimetable.pickup_days_err}
              </Text>
            )}
            <Spacer height={1.5} />
          </Col>
        </div>
      )}

      {isDelivery && (
        <>
          <Col lg={10.5} md={10.5} sm={10.3} xs={9.8}>
            <>
              <CustomInputField
                type="text"
                bgTransparent
                disabled={!isDelivery}
                label="Delivery distance in Radius"
                placeholder="Enter the mile radius you deliver"
                handleChange={(e: any) => {
                  setDistanceError("");
                  if (e === "") {
                    setDistanceError("delivery distance is required");
                  }
                  setDistance(e);
                }}
                value={distance}
                error={distanceError}
                errorMsg={distanceError}
                required
                allowOnlyNumbers={true}
              />
              <Spacer height={1.5} />
            </>
          </Col>
          <Col lg={6}>
            <CustomInputField
              // disabled={!allowToOrder}
              label="Delivery fee"
              bgTransparent
              type="number"
              placeholder="Enter"
              handleChange={(value: any) => {
                setDeliveryFee(value);
              }}
              allowOnlyNumbers={true}
              value={deliveryFee}
            />
            <Spacer height={1.5} />
          </Col>
        </>
      )}
      {isDelivery && (
        <div style={{ position: "relative" }}>
          <RadiusText align="center" direction="row">
            <Text type="small" color="gray">
              Radius
            </Text>
            <Spacer height={1.5} />
          </RadiusText>
        </div>
      )}

      {!isDelivery && <Col lg={6} />}

      <div style={{ width: "100%", margin: "1rem" }}>
        <Flexed
          direction="row"
          justify="space-between"
          style={{ flexWrap: "wrap" }}
        >
          <div style={{ flex: "1 1 48%", minWidth: "250px" }}>
            <AutoComplete
              tags={chemicalsUsed}
              setTags={setChemicalsUsed}
              bgTransparent={true}
              disabled={toggle === true}
              label="Chemical Used"
              suggestions={chemicals}
              error={chemicalsError}
              errorMsg={chemicalsError}
              setError={setChemicalsError}
            ></AutoComplete>
            <Spacer height={1.5} />
          </div>

          <div style={{ flex: "1 1 48%", minWidth: "250px" }}>
            <OrganicFlexed
              direction="row"
              gap={0.5}
              align="flex-end"
              justify="flex-end"
            >
              <Flexed direction="row" gap="0.5" onClick={() => {}}>
                <Text type="small" color="gray">
                  Organic
                </Text>
                <div
                  onClick={() => {
                    if (toggle === false) {
                      if (chemicals?.length > 0) {
                        setIsChemicalsErrorModalOpen(true);
                      } else {
                        toast.success(
                          "If you choose organic, it means that no chemicals were used on your crops. But if you use other natural products to treat your crops, please list it in the product description",
                          {
                            autoClose: 10000
                          }
                        );
                        setIsAddChemicalsModalOpen(toggle);
                      }
                    } else {
                      setIsAddChemicalsModalOpen(toggle);
                    }
                  }}
                >
                  <Toggle setToggle={setToggle} toggle={toggle} />
                </div>
              </Flexed>
            </OrganicFlexed>
          </div>
        </Flexed>
      </div>

      <Col lg={6}>
        <CustomInputField
          // disabled={!allowToOrder}
          label="Service fee"
          bgTransparent
          type="number"
          placeholder="Enter"
          handleChange={(value: any) => {
            setServiceFee(value);
          }}
          allowOnlyNumbers={true}
          value={serviceFee}
        />
        <Spacer height={1.5} />
      </Col>

      <Col>
        <Spacer height={1.5} />
        <CustomInputField
          bgTransparent
          type="textarea"
          label="Caption (Upto 150 words)"
          placeholder="Info that will make your product stand out
							(up to 150 words)"
          handleChange={(e: any) => {
            setCaptionError("");
            if (e === "") {
              setCaptionError("Description is required");
            }
            setCaption(e);
          }}
          value={caption}
          error={captionError}
          errorMsg={captionError}
          required
          textAreaRows={6}
        />
        <Spacer height={1.5} />
      </Col>
      {isChemicalsErrorModalOpen && (
        <ChemicalsErrorModal
          onClose={() => {
            setIsChemicalsErrorModalOpen(false);
          }}
        />
      )}
      {isAllowToOrderModalOpen && (
        <AllowToOrderModal
          onClose={() => {
            setIsAllowToOrderModalOpen(false);
          }}
        />
      )}
    </>
  );
};

const CalendarIconCustom = styled(BiCalendarAlt)`
  color: ${palette.gray};
  font-size: 1.5rem;
`;
const InputWrapper = styled.div`
  position: relative;
`;
const StyledFlex = styled(Flexed)`
  align-self: center;
  justify-content: center;
`;
const StyledWrapper = styled.div`
  position: absolute;
  top: -0.8rem;
  left: 0.5rem;
  font-weight: 500;
  background-color: ${palette.white};
  padding: 0 0.2rem;
  z-index: 1;
`;

const CalenderDiv = styled(DateTimePicker)<any>`
  font-family: "Lato-Regular", sans-serif;
  width: 100%;
  line-height: 1.25rem;
  outline: none;
  font-weight: 400;
  text-align: left;
  font-size: 0.875rem;
  border-radius: 0.5rem;
  padding: 0.6rem 1.25rem;
  border: 1px solid
    ${({ error, disabled, isDarkTheme }) =>
      disabled
        ? `${palette.green}`
        : error
        ? `${palette.danger}`
        : isDarkTheme
        ? `${palette.stroke}`
        : `${palette.stroke}`};
  color: ${({ disabled, isDarkTheme }) =>
    disabled || isDarkTheme
      ? `${palette.text_black}`
      : `${palette.text_black}`};
  width: 100%;
  // cursor: ${({ disabled }) => (disabled ? `no-drop` : `pointer`)};
  background: ${({ disabled, bgTransparent, isDarkTheme }) =>
    bgTransparent
      ? "transparent"
      : disabled
      ? `${palette.silver}`
      : isDarkTheme
      ? `${palette.black}`
      : `${palette.white}`};

  // &:hover {
  // 	box-shadow: 0 0 0.31rem ${({ error, disabled }) =>
    disabled ? "none" : error ? `${palette.danger}` : "rgba(0, 0, 0, 0.25)"};
  // }
  &:focus {
    border: 1px solid
      ${({ error, disabled }) =>
        disabled
          ? "none"
          : error
          ? `${palette.danger}`
          : `${palette.Btn_dark_green}`};
  }
  &::placeholder {
    color: ${palette.gray_100};
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${({ disabled, isDarkTheme }) =>
      disabled || isDarkTheme ? `${palette.silver}` : `${palette.gray_100}`};
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    // color: ${palette.gray_100};
  }
`;
const TextLabel = styled(Text)`
  font-weight: 500;
  text-transform: normal;
`;

const RadiusText = styled(Flexed)`
  position: absolute;
  top: 2.5rem;
`;
const CustomSpacer = styled.div`
  ${media.lg`height: 1.688rem`};
`;
const OrganicFlexed = styled(Flexed)`
  ${media.lg`margin:1.5rem 0rem 0rem 0rem;`};
`;

const CheckboxItem = styled.div`
  flex: 1;
  min-width: 200px;
`;

const WeekDays = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  & .eTfXTe {
    & .bplObn {
      padding-left: 0 !important;
    }
  }

  @media (max-width: 768px) {
    justify-content: space-between;

    & > div:nth-child(n + 5) {
      margin-top: 10px;
    }

    & > div:nth-child(-n + 4) {
      width: calc(25% - 15px);
    }

    & > div:nth-child(n + 5) {
      width: calc(33.33% - 15px);
    }
  }

  @media (max-width: 480px) {
    gap: 10px;
  }
`;

const ResponsiveCheckboxContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export default EditProductStepperTwo;
